import { createSelector } from '@reduxjs/toolkit';

import { sortByPriorityNative } from 'app/lib/sortByPriorityImmutableData';
import type {
  BettingPresentationSelectors,
} from 'app/redux/betting-presentation/grid/selectors';

// турниры с уровнем 1
// объединения с уровнем 1
// турниры с уровнем 2
// объединения с уровнем 0
// турниры с уровнем 0
// стадии с уровнем 0

// s0(t1(u0))
// s0(t0(u1))
// s0(t2(u1))
// s0(t2(u0))

export const selectTournamentsGroupedByPromotionLevel = (
  selectAllSportsGrid: BettingPresentationSelectors['allSportsGridSelector'],
) => {
  return createSelector(
    selectAllSportsGrid,
    (tournamentsWithHierarchyBySport) => {
      const result = new Map();

      tournamentsWithHierarchyBySport.forEach((tournamentsWithHierarchy, sportId) => {
        const groupedTournaments = new Map([
          ['t1', new Map()], // all tournaments with promotionLevel 1 in all unions
          ['u1t0', new Map()], // all tournaments with promotionLevel 0 in unions with promotionLevel 1
          ['t2', new Map()], // all tournaments with promotionLevel 2 in all unions
          ['u0t0', new Map()], // all tournaments with promotionLevel 0 in unions with promotionLevel 0
        ]);

        tournamentsWithHierarchy.forEach((tournament) => {
          if (tournament.promotionLevel === 1) {
            return groupedTournaments.get('t1')?.set(
              tournament.id,
              tournament,
            );
          }

          if (tournament.promotionLevel === 2) {
            return groupedTournaments.get('t2')?.set(
              tournament.id,
              tournament,
            );
          }

          if (tournament.union.promotionLevel === 1) {
            return groupedTournaments.get('u1t0')?.set(
              tournament.id,
              tournament,
            );
          }

          return groupedTournaments.get('u0t0')?.set(
            tournament.id,
            tournament,
          );
        });

        const tournamentsBySport = new Map();

        groupedTournaments.forEach((mathcesIdsByTournaments, key) => {
          if (key.includes('u')) {
            mathcesIdsByTournaments.forEach((value, tournamentId) => {
              tournamentsBySport.set(
                tournamentId,
                value);
            });
          }
          else {
            const sortedTournaments = sortByPriorityNative(mathcesIdsByTournaments);

            sortedTournaments.forEach((tournamentId) => {
              tournamentsBySport.set(
                tournamentId,
                mathcesIdsByTournaments.get(tournamentId));
            });
          }
        });

        result.set(sportId, tournamentsBySport);
      });

      return result;
    },
  );
};
